import { useState } from 'react';
import css from './index.module.scss';
import { createPortal } from 'react-dom';
import EFPicture from '@elem/compCommon/EFPicture';

export default function CastCardPopUp({ callback }: any) {
    return (
        <div className={`castCard-popup ${css['castCard-popup']}`}>
            <div className="castCard-popup-content">
                <header className="castCard-popup-header">
                    <span>EcoFlow Certified Contractor Map</span>
                    <svg
                        className="header-close"
                        onClick={() => callback(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="castCard-popup-body">
                    <div className="img">
                        <EFPicture
                            src="https://websiteoss.ecoflow.com/upload/image/1747798842988/Frame%201612707019.png"
                            srcMobile="https://websiteoss.ecoflow.com/upload/image/1747798768657/Frame%201612707020.png"
                        ></EFPicture>
                    </div>
                </body>
            </div>
        </div>
    );
}
